import type { VaultMetadata } from '@/types'

export function getVaultProtocolName(metadata: VaultMetadata) {
  const version = metadata.protocol?.version
  const suffix = version ? ` ${version}` : ''

  return metadata.protocol.name + suffix
}
